import { store } from '../store/store';

const ForgotPassword = async (email) => {
    const state = store.getState();
    const API_BASE = state.user.apiBase;

    try {
        const response = await fetch(`${API_BASE}/users/forgottenpassword/${email.toLowerCase()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error requesting password reset:", error);
        throw error;
    }
};

export default ForgotPassword;
